export default "__VITE_ASSET__BaDqhC14__"